import { Component, ContentChild, OnInit, Optional, TemplateRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { HideNavbarsService } from '../hide-navbars.service';
import { BaseLink } from '../models/base-link';
import { WlmNavigationService } from '../wlm-navigation.service';

const COMPONENT_SELECTOR = 'wlm-nav-bar';

@UntilDestroy()
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  standalone: false,
})
export class NavBarComponent implements OnInit {
  @ContentChild('appLogo') appLogoRef: TemplateRef<any>;

  modulesLink: Array<BaseLink> = [];
  expanded = true;

  readonly hideNavBar$: Observable<boolean>;

  constructor(
    private readonly _navService: WlmNavigationService,
    @Optional() private readonly _hideNavbarsService: HideNavbarsService
  ) {
    this.hideNavBar$ = this._hideNavbarsService.hideNavBar$;
  }

  ngOnInit(): void {
    this._navService
      .getNavigationModules()
      .pipe(untilDestroyed(this))
      .subscribe((modules) => {
        this.modulesLink = modules;
      });
  }
}
